export default {
  "Sources": "Sources",
  "Show more sources": "Afficher plus",
  "Show less sources": "Afficher moins",
  "Auto": "Auto",
  "Always on": "Toujours actif",
  "Always off": "Toujours désactivé",
  "Next": "Suivant",
  "Prev": "Préc",
  "You have no source yet. Click \"Live sources\" or \"Media\" to add one.": "Vous n'avez pas encore de source. Cliquez sur \"Sources live\" ou \"Médias\" pour en ajouter."
}
